import { render, staticRenderFns } from "./GameFlappyEnna.vue?vue&type=template&id=7b0f5b74&scoped=true&"
import script from "./GameFlappyEnna.vue?vue&type=script&lang=js&"
export * from "./GameFlappyEnna.vue?vue&type=script&lang=js&"
import style0 from "./GameFlappyEnna.vue?vue&type=style&index=0&id=7b0f5b74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0f5b74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
